import { Component, input } from '@angular/core';

@Component({
  selector: 'app-visor-codigo-qr',
  templateUrl: './visor-codigo-qr.component.html',
  standalone: false,
  styleUrls: ['./visor-codigo-qr.component.css']
})
export class VisorCodigoQrComponent {

  readonly titulo = input<string>('');
  readonly tituloQr = input<string>('');
  readonly contenidoQr = input<string>('');

  constructor() { 
  }

  ngOnInit(): void {
  }
}
